import React from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

// import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

import CircularProgress from '@mui/material/CircularProgress';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
import SheetMusicPlayer from './SheetMusicPlayer';

import Alert from '@mui/material/Alert';
import { styled } from '@mui/material/styles';

import domtoimage from 'dom-to-image';

import ScoreDisplayer from "../ScoreDisplayer.js"

import { jsPDF } from "jspdf";

import TextManager from '../TextManager';

const StyledButton = styled(Button)(({ theme }) => ({
	width: "220px"
}));

StyledButton.defaultProps = {
    ...StyledButton.defaultProps,
    variant: "contained"
}

export default class ScoreCreationDialog extends React.Component {
	xmlFileInputElem = React.createRef();
	pdfFileInputElem = React.createRef();

	state = {
		newScoreSelected: false,
	}

	componentWillUnmount() {
		this.setState({newScoreSelected: false});
	}

	onXmlFileInputElementChanged = async (inputElement) => {
		if (inputElement.files.length > 0) {
			let success = await this.props.scoreProcessingProgressManager.sendProcessMxlRequest(inputElement.files[0]);
			inputElement.value = null;
			console.log(success);
			if (success) {
				this.props.close();
				this.props.setFileList?.call(this, []);
			}
		}
	}

	onPdfFileInputElementChanged = async (inputElement) => {
		if (inputElement.files.length > 0) {
			let success = await this.props.scoreProcessingProgressManager.sendProcessPdfRequest(inputElement.files[0]);
			inputElement.value = null;
			if (success) {
				this.props.close();
				this.props.setFileList?.call(this, []);
			}
		}
	}

	render() {
		//console.log(this.state.newScoreSelected)
		if (this.props.fileList.length > 0 && !this.state.newScoreSelected) {
			return (
				<div className="PopupPage">
					<Stack spacing={2} direction="column" alignItems="center">
						<StyledButton onClick={() => {
							this.setState({newScoreSelected: true})
						}}>
							{TextManager.getText("new_score")}
						</StyledButton>
						<StyledButton onClick={() => {
							this.props.openScoreManagement(false)
						}}>
							{TextManager.getText("edit_score")}
						</StyledButton>
						<StyledButton onClick={this.props.close} variant="contained">{TextManager.getText("cancel")}</StyledButton>
					</Stack>
				</div>
			);

		} else {
			return (
				<div className="PopupPage">
					<Stack spacing={2} direction="column" alignItems="center">
						<StyledButton  onClick={() => {
							this.props.openScoreManagement(true);
							this.props.close();
						}}>
							{TextManager.getText("scan_photos")}
						</StyledButton>
						<StyledButton variant="contained" onClick={() => this.pdfFileInputElem.current.click()}>{TextManager.getText("scan_pdf")}</StyledButton>
						<StyledButton variant="contained" onClick={() => this.xmlFileInputElem.current.click()}>{TextManager.getText("load_xml")}</StyledButton>
						<StyledButton onClick={() => {
							this.setState({newScoreSelected: false})
							this.props.close();
						}} variant="contained">{TextManager.getText("back")}</StyledButton>
					</Stack>
						<input ref={this.xmlFileInputElem} type="file" accept=".xml,.mxl" hidden onChange={e => this.onXmlFileInputElementChanged(e.target)} />
						<input ref={this.pdfFileInputElem} type="file" accept=".pdf" hidden onChange={e => this.onPdfFileInputElementChanged(e.target)} />
				</div>
			);

		}
	}
}